const SPOTIFY_SILENT_AUTH = 'ssa';
class Storage {
    write(item) {
        localStorage.setItem(SPOTIFY_SILENT_AUTH, JSON.stringify(item));
    }
    readAndClear() {
        const item = localStorage.getItem(SPOTIFY_SILENT_AUTH);
        return item ? JSON.parse(item) : null;
    }
}
export const storage = new Storage();
//# sourceMappingURL=storage.js.map